<style>

h3{
  text-align: center;
}

.space{
  margin: 20px;
}

.photos{
  display: grid;
  grid-template-columns: 50% 50%;
  grid-auto-rows: 165px;
  align-items: center;
  justify-items: center;
}
.r1c1{
  grid-column: 1;
  grid-row: 1;
}
.r1c2{
  grid-column: 2;
  grid-row: 1;
}
.r2c1{
  grid-column: 1;
  grid-row: 2;
}
.r2c2{
  grid-column: 2;
  grid-row: 2;
}
.r3c1{
  grid-column: 1;
  grid-row: 3;
}
.r3c2{
  grid-column: 2;
  grid-row: 3;
}

.photo{
  width: 150px;
  height: 150px;
  border: 2px #777 solid;
  /* border-radius: 150px; */
  border-radius: 10px;
  margin: auto;
}

.plus{
  width: 150px;
  height: 150px;
  padding: 47px 0 0 3px;
  font-size: 41px;
  color: white;
  text-align: center;
}

.pic{
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}


/* add/edit images */
.image{
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 500px;
}

.out{
  border: 1px gray solid;
  margin-bottom: 10px;
  display: none;
}
.button-container{
  position: fixed;
  z-index: 51;
  left: 0;
  right: 0;
  bottom: 51px;
}
.buttons{
  margin: 20px;
}

.center{
  text-align: center;
  color: white;
}
.icon-supervised_user_circle{
  font-size: 150px;
}
.icon-camera_alt{
  font-size: 50px;
}

</style>

{#if show}


{#if add}
  
  {#if photo}
    
  <div class="image">
    <Cropper image="{photo}" bind:crop bind:zoom aspect="{1}" on:cropcomplete="{doCrop}"></Cropper>
  </div>

  <!-- hidden element -->
  <div class="out">
    <img id="image" src="{out}" alt="">
  </div>

  <!-- hidden element -->
  <div class="out">
    <canvas id="canvas" width="1000px" height="1000px"></canvas>
  </div>
  
  <div class="button-container">
    <div class="buttons">
      <button on:click="{addPhoto}">Upload New Photo</button>
    </div>
    <div class="buttons">
      <button on:click="{clearPhoto}">Clear Photo</button>
    </div>
  </div>

  {:else}

  <div class="title-signup" on:click="{addPhoto}">Add a photo</div>

  <div class="center" on:click="{addPhoto}">
    <i class="icon-supervised_user_circle"></i>
  </div>

  <div class="center" on:click="{addPhoto}">
    <i class="icon-camera_alt"></i>
  </div>

  <div class="buttons">
    <button on:click="{addPhoto}">+ Add Photo</button>
  </div>
  
  {/if}
  
  <input style="display:none" type="file" accept=".jpg, .jpeg, .png" on:change="{ (e) => onFileSelected(e) }" bind:this="{fileInput}" >
  
{:else}
  
<h3>Add photos</h3>
  
<div class="photos">
  <div class="r1c1">
    <div class="photo">
      {#if iphotos[0].p}
        <!-- load local image -->
        <img src="{iphotos[0].p}" class="pic" on:click="{ () => photoClicked(0) }">
      {:else}
        <!-- no image yet... -->
        <div class="plus" on:click="{ () => photoClicked(0) }">+</div>
      {/if}
    </div>
  </div>
  <div class="r1c2">
    <div class="photo">
      {#if iphotos[1].p}
        <img src="{iphotos[1].p}" class="pic" on:click="{ () => photoClicked(1) }">
      {:else}
        <div class="plus" on:click="{ () => photoClicked(1) }">+</div>
      {/if}
    </div>
  </div>
  
  <div class="r2c1">
    <div class="photo">
      {#if iphotos[2].p}
        <img src="{iphotos[2].p}" class="pic" on:click="{ () => photoClicked(2) }">
      {:else}
        <div class="plus" on:click="{ () => photoClicked(2) }">+</div>
      {/if}
    </div>
  </div>
  <div class="r2c2">
    <div class="photo">
      {#if iphotos[3].p}
        <img src="{iphotos[3].p}" class="pic" on:click="{ () => photoClicked(3) }">
      {:else}
        <div class="plus" on:click="{ () => photoClicked(3) }">+</div>
      {/if}
    </div>
  </div>
  
  <div class="r3c1">
    <div class="photo">
      {#if iphotos[4].p}
        <img src="{iphotos[4].p}" class="pic" on:click="{ () => photoClicked(4) }">
      {:else}
        <div class="plus" on:click="{ () => photoClicked(4) }">+</div>
      {/if}
    </div>
  </div>
  <div class="r3c2">
    <div class="photo">
      {#if iphotos[5].p}
        <img src="{iphotos[5].p}" class="pic" on:click="{ () => photoClicked(5) }">
      {:else}
        <div class="plus" on:click="{ () => photoClicked(5) }">+</div>
      {/if}
    </div>
  </div>
</div>

{/if}

{/if}


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Cropper from "svelte-easy-crop";

import Generate from "../../helpers/Generate.js";
import Photos from "../../helpers/Photos.js";

export let show = false;
export let event = null;
export let photos = [];
export let photosToDelete = [];

let add = false;

/* 

this is just used with saveProfilePhotos on the back end.  the photoIds array is still the same everywhere else because we want to preserve the order that they were loaded.

{c: "command", i: "id", p: "photo data"}

"c" can be "nop", "new", "delete", "change"
"i" is new id
"p" is photo data

if nop, that was an already saved pic that is being reloaded into the array.
if new, that is a new photo that needs to be saved
if delete, then delete that photo id
if change, then delete

because "doCrop" wants to be run, even after deleting a photo, it generates a new ID for the deleted photo, which is pretty stupid.  when deleting a photo, we need to copy "o" back to "i"

*/

// internal photos
let iphotos = [ 
  {c: "nop", i: "", p: ""},
  {c: "nop", i: "", p: ""},
  {c: "nop", i: "", p: ""},
  {c: "nop", i: "", p: ""},
  {c: "nop", i: "", p: ""},
  {c: "nop", i: "", p: ""},
];

// add ids to delete from server
let toDelete = [];

let curPhotoId = null;

let eid = "";
let photo = "";
let crop = { x: 0, y: 0 };
let zoom = 1;
let out = "";
let image = new Image();
let canvas = null;
let ctx = null;
let fileInput = "";

let tempPhoto = "";


$:{
  if (photos) set();
}


function set() {
  
  if (show == false) return;
  
  eid = event.eid;
  iphotos = JSON.parse( JSON.stringify(photos) );
  console.log("iphotos:", iphotos);
  
  for (let i in iphotos) {
    
    if (iphotos[i].p.includes("/ei/") == true) {
      
      let img = new Image;
      img.crossOrigin = 'Anonymous';
      
      img.onload = () => {
        // console.log("img.src:", img.src);
        let tcanvas = document.createElement('canvas');
        let tctx = tcanvas.getContext('2d');
        tcanvas.width = img.naturalWidth;
        tcanvas.height = img.naturalHeight;
        tctx.drawImage(img, 0, 0);
        iphotos[i].p = tcanvas.toDataURL("image/jpeg");
        // iphotos[i].i = photoIds[i];
      }
      
      img.src = `https://routes.hot0.workers.dev/ei/${localStorage.getItem('cookie')}/${localStorage.getItem('csrf')}/${eid}/${iphotos[i].i}`;
      
    }
    
  }
  
  // console.log("set iphotos:", iphotos);
}


function photoClicked(index) {
  // console.log("photoClicked");
  add = true;
  curPhotoId = index;
  photo = iphotos[curPhotoId].p;
  image.src = photo;
}


function addPhoto() {
  fileInput.click();
}


function onFileSelected(e) {
  if (e.target.files.length > 0) {
    let timage = e.target.files[0];
    let treader = new FileReader();
    treader.readAsDataURL(timage);
    treader.onload = async (e) => {
      photo = e.target.result;
      image.src = photo;
    };
  }
}


async function doCrop(e) {
  
  // console.log("doCrop");
  
  canvas = document.getElementById('canvas');
  ctx = canvas.getContext('2d');
  
  let x = e.detail.pixels.x;
  let y = e.detail.pixels.y;
  let w = e.detail.pixels.width;
  let h = e.detail.pixels.height;
  
  ctx.drawImage(image,
        x, y,   // Start at x,y pixels from the left and the top of the image (crop),
        w, h,   // "Get" a w,h area from the source image (crop),
        0, 0,     // Place the result at 0, 0 in the canvas,
        1000, 1000); // With as w,h: 100, 100 (scale)  
  
  let tPhoto = canvas.toDataURL();
  tempPhoto = await Photos.resize(tPhoto, 800, 800, 0.7);
}


async function clearPhoto() {
  photo = "";
  
  if (iphotos[curPhotoId].i != "") {
    toDelete.push(iphotos[curPhotoId].i);
  }
  iphotos[curPhotoId].c = "nop";
  iphotos[curPhotoId].i = "";
  iphotos[curPhotoId].p = "";
  iphotos[curPhotoId].m = "";
  iphotos[curPhotoId].t = "";
  tempPhoto = "";
  photo = "";
  
  // console.log("clearPhoto");
  // console.log("toDelete:", toDelete);
}


function check() {
  try {
    
    let imagesExist = false;
    for (let i in iphotos) {
      if (iphotos[i].p != "") {
        imagesExist = true;
        break;
      }
    }
    
    if (imagesExist == false) throw "At least one image needs to be uploaded.";
    
  } catch (e) {
    console.log("error:", e);
  }
}


function done() {
  // console.log("done");
  add = false;
  if (iphotos[curPhotoId].p == "" && tempPhoto != "") {
    // console.log("new photo");
    // we have a new photo
    iphotos[curPhotoId].c = "new";
    iphotos[curPhotoId].i = Generate.id();
    iphotos[curPhotoId].p = tempPhoto;
  } else if (iphotos[curPhotoId].p != "") {
    // console.log("overwriting photo");
    // first, delete the old photo
    toDelete.push(iphotos[curPhotoId].i);
    // console.log("toDelete:", toDelete);
    // add the new
    iphotos[curPhotoId].c = "new";
    iphotos[curPhotoId].i = Generate.id();
    iphotos[curPhotoId].p = tempPhoto;
  }
}


export const save = async () => {
  
  if (add == true) {
    done();
  } else {
    
    photos = iphotos;
    photosToDelete = toDelete;

    event.photoIds = [];
    for (let i in iphotos) {
      if (iphotos[i].p != "") {
        event.photoIds.push(iphotos[i].i);
      }
    }
    
    // create some empty space
    // console.log("photoIds.length:", photoIds.length);
    while (event.photoIds.length < 6) {
      event.photoIds.push("");
    }
    
    console.log("event.photoIds:", event.photoIds);
    console.log("photos:", photos);
    show = false;
    
  }
  
}


</script>